import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Card } from '@/components/ui/card';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '@/components/ui/accordion';
import { ArrowLeft, HelpCircle, Users, Lock, MapPin, DollarSign, BarChart3, Smartphone } from 'lucide-react';

export default function HelpPage() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen" style={{backgroundColor: '#000'}}>
      <header className="border-b" style={{borderColor: '#333'}}>
        <div className="max-w-6xl mx-auto px-6 py-4 flex items-center justify-between">
          <h1 className="text-2xl font-bold" style={{fontFamily: 'Space Grotesk, sans-serif', color: '#00FF66'}}>
            Help & FAQ
          </h1>
          <Button variant="outline" onClick={() => navigate(-1)} style={{borderColor: '#333', color: '#00FF66'}}>
            <ArrowLeft className="h-4 w-4 mr-2" />
            Back
          </Button>
        </div>
      </header>

      <div className="max-w-6xl mx-auto px-6 py-12 space-y-8">
        <Card className="p-8 text-center" style={{backgroundColor: '#1a1a1a', borderColor: '#00FF66'}}>
          <h3 className="text-2xl font-bold mb-4" style={{color: '#00FF66'}}>TurfSense v4.0</h3>
          <p style={{color: '#CCC'}}>AI-Powered Smart Ground Management</p>
          <p className="text-sm mt-4" style={{color: '#888'}}>
            For detailed documentation, see README.md in project root
          </p>
        </Card>
      </div>
    </div>
  );
}
